"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _query = _interopRequireDefault(require("./query"));
var _result = _interopRequireDefault(require("./result"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var search = function search(client) {
  return function (clientFilter) {
    var filter = clientFilter || {};
    var query = (0, _query["default"])(filter);
    return client.search({
      type: 'plan',
      query: JSON.stringify(query)
    }).then((0, _result["default"])(filter));
  };
};
var _default = exports["default"] = search;
module.exports = exports["default"];